import moment from "moment";
import { useTranslation } from "react-i18next";

export const Bookingetails = (props) => {
  const { t } = useTranslation();
  const { booking, branding } = props;
  const customContentColor = {
    color: branding.paragraphColor,
    fontFamily: branding.paragraphFont,
  };
  return (
    <table className="booking-detail-wrapper">
      <tbody>
        <tr>
          <th className="custom-booking-details-header">{t("booking.confirmation.booking_id")}</th>
          <td
            className="custom-booking-details-content"
            style={customContentColor}
          >
            {booking.bookingId}
          </td>
        </tr>
        <tr>
          <th className="custom-booking-details-header">{t("booking.confirmation.transaction_id")}</th>
          <td
            className="custom-booking-details-content"
            style={customContentColor}
          >
            {booking.transactionId || "N/A"}
          </td>
        </tr>
        <tr>
          <th className="custom-booking-details-header">{t("booking.confirmation.payment_method")}</th>
          <td
            className="custom-booking-details-content"
            style={customContentColor}
          >
            {booking.paymentMethod || "N/A"}
          </td>
        </tr>
        <tr>
          <th className="custom-booking-details-header">{t("booking.confirmation.check_in_date")}</th>
          <td
            className="custom-booking-details-content"
            style={customContentColor}
          >
            {moment(booking.fromdate, "DD-MM-YYYY").format("DD-MMM-YYYY")}
          </td>
        </tr>
        <tr>
          <th className="custom-booking-details-header">{t("booking.confirmation.check_out_date")}</th>
          <td
            className="custom-booking-details-content"
            style={customContentColor}
          >
            {moment(booking.todate, "DD-MM-YYYY").format("DD-MMM-YYYY")}
          </td>
        </tr>
        <tr>
          <th className="custom-booking-details-header">{t("booking.confirmation.total_nights")}</th>
          <td
            className="custom-booking-details-content"
            style={customContentColor}
          >
            {booking.totaldays}
          </td>
        </tr>
        <tr
          style={{
            backgroundColor: branding.headingColor,
            fontFamily: branding.headingFont,
          }}
        >
          <th
            className="padding-10"
            style={{ textAlign: "left", color: "white" }}
          >
            {t("booking.confirmation.grand_total")}
          </th>
          <td
            className="custom-booking-details-content"
            style={{
              fontSize: "20px",
              color: "#fff",
            }}
          >
            {booking.totalamount.toLocaleString()} VND
          </td>
        </tr>
        <tr>
          <td
            colSpan="2"
            className="padding-10"
            style={{
              ...customContentColor,
              textAlign: "center",
              fontSize: "14px",
            }}
          >
            <strong>
              {t("booking.confirmation.policy_service")}
            </strong>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
